export default {
    title: "已提交调查",
    header: "@:views.survey.submitted.title",
    message: "感谢您的反馈意见。",
}